<template> 
  <section class="honor-container" ref="rootRef"> 
     
    <!-- SINGLE TEXT --> 
    <div class="frase-container"> 
      <p ref="fraseRef" class="frase-texto"> 
        May the Lord grant you the desires of your heart and fulfill all your plans. 
      </p> 
 
      <p ref="salmoRef" class="salmo-ref">Psalm 20:4</p> 
    </div> 
 
  </section> 
</template>
<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CuadroDeHonor',
  setup() {

    const rootRef = ref(null)
    const fraseRef = ref(null)
    const salmoRef = ref(null)

    onMounted(async () => {
      await nextTick()

      // Estado inicial
      gsap.set([fraseRef.value, salmoRef.value], {
        opacity: 0,
        y: 30
      })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({
            defaults: { ease: 'power2.out' }
          })

          // ✨ Frase principal
          tl.to(fraseRef.value, {
            opacity: 1,
            y: 0,
            duration: 1
          })

          // ✨ Salmo (entra después, más delicado)
          tl.to(salmoRef.value, {
            opacity: 0.8,
            y: 0,
            duration: 0.8
          }, '-=0.4')

          io.disconnect()
        })
      }, { threshold: 0.4 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return {
      rootRef,
      fraseRef,
      salmoRef
    }
  }
}
</script>

<style scoped>
.frase-container{
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.frase-texto{
  font-family: 'quote', serif;
  font-size: 20px;
  color: #ffffff;
  line-height: 1.7;
}

.salmo-ref{
  display: block;
  text-align: right;
  margin-top: 6px;

  font-size: 16px;
  color: #fdfdfd;
  font-family: 'quote', serif;
}
/* Contenedor general – rosa elegante como tus secciones previas */
.honor-container{
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 42px 18px 56px;
  background: #f0c9d3;
  background-image:
    linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,0)),
    radial-gradient(1000px 400px at 50% -10%, rgba(255,255,255,.32), rgba(255,255,255,0) 60%),
    linear-gradient(180deg, #f5b9c9, #f5b9c9);
  border-radius: 18px;
  box-shadow: 0 10px 28px rgba(0,0,0,.08);
}

/* Header */
.honor-header{ text-align:center; margin-bottom: 18px; }
.title-serif{
  font-family: 'quote', serif;
  font-size: 36px;
  color: #fff;
  line-height: 1.05;
  margin: 0 0 8px;
}
.title-line{
  width: 64px; height: 2px; margin: 0 auto;
  background: #fff; opacity: .85; border-radius: 2px;
}

/* Chambelán de honor – tarjeta destacada */
.honor-hero{
  text-align: center;
  border-radius: 16px;
  padding: 18px 16px;
  margin: 18px auto 24px;
  max-width: 680px;
}
.hero-label{
  font-family: 'britishgruesa', serif;
  font-size: 44px;
  color: #ffffff;
  font-weight: 800;
}
.hero-name{
  font-family: 'quote', cursive;
  font-size: 24px;
  color: #ffffff;
  margin: 0;
}

/* Secciones */
.honor-section{ margin-top: 8px; }
.section-title{
  text-align: center;
  font-family: 'britishgruesa', serif;
  font-weight: 800;
  letter-spacing: .16em;
  font-size: 44px;
  color: #ffffff;
  margin: 10px 0 12px;
}

/* Grid de nombres */
.honor-grid{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
}
.honor-item{
  opacity: 0; /* se anima a 1 con GSAP */
}
.honor-chip{
  display: block;
  width: 100%;
  padding: 12px 14px;
  color: #ffffff;
  border-radius: 14px;
  font-family: 'quote', serif;
  font-size: 24px !important;
  text-align: center;
}

/* Hover sutil en desktop */
@media (hover:hover){
  .honor-chip:hover{
    transform: translateY(-1px);
    transition: transform .18s ease, box-shadow .18s ease;
    box-shadow: 0 10px 18px rgba(0,0,0,.12), inset 0 1px 0 rgba(255,255,255,.75);
  }
}

/* Responsive fino */
@media (max-width: 420px){
  .title-serif{ font-size: 40px; }
  .hero-name{ font-size: 28px; }
  .honor-chip{ font-size: 15px; padding: 11px 12px; }
}
</style>
